import { createReducer } from 'redux-starter-kit';
import {
  fetchBundles,
  fetchBundlesSuccess,
  fetchBundlesFailure,
  setRelatedSearches,
  resetSettings,
  cacheSettings,
  clearResults,
  setSearchFor,
  searchFor,
  filterByLevel,
  filterByCateg,
  changeOrder,
  preloadBundle,
  fetchBundle,
  fetchBundleSuccess,
  fetchBundleFailure,
  fetchAudios,
  fetchAudiosSuccess,
  fetchAudiosFailure,
  resetAudiosSettings,
  clearCurrentBundle,
  fetchUltimateBundle,
  fetchUltimateBundleSuccess,
  fetchUltimateBundleFailure
} from 'actions/bundles';
import { loginSuccess, registerSuccess, logout } from 'actions/auth';

const defaultSettings = {
  level: 'all',
  searchFor: '',
  orderBy: 'created_at desc',
  categId: null,
  currentPage: 0,
  audiosCurrentPage: 0
};
const defaultAudiosSettings = {
  searchForAudios: '',
  audioList: [],
  totalAudiosCount: 0,
  audiosCurrentPage: 0,
  audiosBatchSize: 10
};
export default createReducer(
  {
    list: [],
    audioList: [],
    relatedSearches: [],
    ...defaultSettings,
    ...defaultAudiosSettings,
    isLoading: false,
    isAudiosLoading: false,
    batchSize: 9,
    hasMore: false,
    currentBundle: null,
    prevState: null,
    isUltimateLoading: false,
    ultimate: null
  },
  {
    [clearResults]: state => ({
      ...state,
      list: [],
      audioList: [],
      currentPage: 0,
      audiosCurrentPage: 0
    }),
    [resetSettings]: state => ({
      ...state,
      ...defaultSettings
    }),
    [resetAudiosSettings]: state => ({
      ...state,
      ...defaultAudiosSettings
    }),
    [cacheSettings]: (state, action) => {
      const { level, searchFor, categId } = state;
      const bundleType = action.payload;
      return {
        ...state,
        prevState: JSON.stringify({ bundleType, level, searchFor, categId })
      };
    },
    // Bundles
    [fetchBundles]: state => ({
      ...state,
      isLoading: true
    }),
    [fetchBundlesSuccess]: (state, action) => ({
      ...state,
      list: [...state.list, ...action.payload.data],
      isLoading: false,
      currentPage: action.payload.current_page,
      hasMore: action.payload.current_page < action.payload.last_page
    }),
    [fetchBundlesFailure]: state => ({
      ...state,
      isLoading: false,
      hasMore: false
      // should also display an error here probably
    }),
    [setRelatedSearches]: (state, action) => ({
      ...state,
      relatedSearches: action.payload || []
    }),
    [setSearchFor]: (state, action) => ({
      ...state,
      searchFor: action.payload
    }),
    [searchFor]: (state, action) => ({
      ...state,
      searchFor: action.payload
    }),
    [filterByLevel]: (state, action) => ({
      ...state,
      level: action.payload
    }),
    [filterByCateg]: (state, action) => ({
      ...state,
      categId: action.payload
    }),
    [changeOrder]: (state, action) => ({
      ...state,
      orderBy: action.payload,
      list: [], // reset results
      currentPage: 0
    }),

    // Bundle
    [preloadBundle]: (state, action) => ({
      ...state,
      currentBundle: action.payload
    }),
    [fetchBundle]: state => ({
      ...state,
      isLoading: true
    }),
    [fetchBundleSuccess]: (state, action) => ({
      ...state,
      currentBundle: action.payload,
      isLoading: false
    }),
    [fetchBundleFailure]: state => ({
      ...state,
      current: false,
      isLoading: false
    }),
    [clearCurrentBundle]: state => ({
      ...state,
      isLoading: false,
      currentBundle: false
    }),

    // ultimate
    [fetchUltimateBundle]: state => ({
      ...state,
      isUltimateLoading: true
    }),
    [fetchUltimateBundleSuccess]: (state, action) => ({
      ...state,
      ultimate: action.payload,
      isUltimateLoading: false
    }),
    [fetchUltimateBundleFailure]: state => ({
      ...state,
      ultimate: null,
      isUltimateLoading: false
    }),

    // Audios of audio bundle
    [fetchAudios]: (state, action) => ({
      ...state,
      isAudiosLoading: true,
      searchForAudios: action.payload !== undefined ? action.payload : state.searchForAudios
    }),
    [fetchAudiosSuccess]: (state, action) => ({
      ...state,
      audioList: action.payload.data,
      totalAudiosCount: action.payload.total,
      isAudiosLoading: false,
      audiosCurrentPage: action.payload.current_page
    }),
    [fetchAudiosFailure]: state => ({
      ...state,
      isAudiosLoading: false,
      searchForAudios: ''
    }),

    // Auth
    [loginSuccess]: state => ({
      ...state,
      list: []
    }),
    [registerSuccess]: state => ({
      ...state,
      list: []
    }),
    [logout]: state => ({
      ...state,
      list: []
    })
  }
);
